import { gql } from '@apollo/client'

export const ACTION_GENERATOR_FRAGMENT = gql`
  fragment ActionGeneratorFragment on ActionGenerator {
    title
    repeatSchedule
    endDate
    masterCategoryId
    stores {
      id
    }
    description
    startDate
    dueDateTime
    actionType
    id
    parentGenerator {
      id
    }
    aiImageCheck
    notifyOnFailure
    notifyOnSuccess
    notifyActiveManager
    notifyOnDeadline
    deadlineNotificationOffsetHours
    peopleToNotify {
      id
      firstName
      lastName
      email
    }
    subGenerators(filters: $subFilters, pagination: $subPagination) {
      id
      title
      description
      dueDateTime
      actionType
      endDate
      aiImageCheck
      notifyOnFailure
      notifyOnSuccess
      notifyActiveManager
      notifyOnDeadline
      deadlineNotificationOffsetHours
      peopleToNotify {
        id
        firstName
        lastName
        email
      }
    }
  }
`
